/**
 * @generated SignedSource<<f1c64d79cbc973aaffaa05f03c1d79ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueTableHierarchyToggle_HierarchyToggle$data = {
  readonly id: string;
  readonly viewConfigSettings?: {
    readonly canEnableGrouping: boolean | null | undefined;
    readonly canEnableHierarchy: boolean | null | undefined;
    readonly isGroupingEnabled: boolean | null | undefined;
    readonly isHierarchyEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly viewId: string | null | undefined;
  readonly viewSettings?: {
    readonly canEnableGrouping: boolean | null | undefined;
    readonly canEnableHierarchy: boolean | null | undefined;
    readonly isGroupingEnabled: boolean | null | undefined;
    readonly isHierarchyEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueTableHierarchyToggle_HierarchyToggle";
};
export type ui_issueTableHierarchyToggle_HierarchyToggle$key = {
  readonly " $data"?: ui_issueTableHierarchyToggle_HierarchyToggle$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableHierarchyToggle_HierarchyToggle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "staticViewInput",
  "variableName": "staticViewInput"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "isHierarchyEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "canEnableHierarchy"
  },
  {
    "kind": "ScalarField",
    "name": "isGroupingEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "canEnableGrouping"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueTableHierarchyToggle_HierarchyToggle",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "viewId"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewConfigSettings",
          "plural": false,
          "selections": (v1/*: any*/)
        }
      ],
      "type": "JiraIssueSearchView"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            (v0/*: any*/)
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": (v1/*: any*/)
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};
})();

(node as any).hash = "0ef1c91b39f748dac1abca24d26eeef2";

export default node;
